import PromoButton from '../PromoButton/PromoButton';

const HREF = 'https://app.hyperliquid.xyz/join/TRADERMAP';

export default function HyperliquidPromo({ shape = 'round', className }) {
  return (
    <PromoButton
      href={HREF}
      accent="#38bdf8"
      shape={shape}
      prefix="Trade on"
      brand="Hyperliquid"
      badge={{ full: '4% FEE DISCOUNT', short: '4% OFF', tiny: '4%' }}
      className={className}
    />
  );
}
